// extracted by mini-css-extract-plugin
module.exports = {"sp-175w-H":"H_sp-175w-H__0sCWP"};